module.exports = __webpack_public_path__ + "img/1528055540.2ab304cf.jpg";